// MainLayout.jsx
import { Container } from "@mui/material";
import PromotionMessage from "../components/promotionMessage";
import Footer from "../components/footer";
import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import DelayedLoadingFallback from "../utils/DelayedLoadingFallback";
import Appbar from "../features/Appbar/appbar";

const MainLayout = () => (
  <>
    <PromotionMessage />
    <Container sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Appbar />
      <Suspense fallback={<DelayedLoadingFallback delay={500} />}>
        <Outlet />
      </Suspense>
    </Container>
    <Footer />
  </>
);

export default MainLayout;
